export class SiteSettingDictionary{
    //-- 属性宽度
    static INPUT_LABEL_WIDTH_FIXED="FIXED";
    static INPUT_LABEL_WIDTH_AUTO="AUTO";

    static LANGUAGE_ZH="zh-cn";
    static LANGUAGE_EN="en-us";

    static CURRENCY_CNY="cny";
    static CURRENCY_USD="usd";
    static CURRENCY_AED="aed";

    static USER_FILE_SERVER_NORMAL="normal";
    static USER_FILE_SERVER_COS="cos";

    static PRICE_RESULT_MODE_DISCOUNT=1;
  //  static PRICE_RESULT_MODE_COMMISSION=2;
    static PRICE_RESULT_MODE_MARKUP=3;

    static PRICE_LIST_MODE_NONE=0;
    static PRICE_LIST_MODE_MEMBER=1;
    static PRICE_LIST_MODE_COMMISSION=2;

    static ADDRESS_FORMAT_FORMATTED=1;
    static ADDRESS_FORMAT_UNFORMATTED=2;
    
}

export class SiteSettingSource{
    //-- 属性宽度
    static InputLabelWidthSource=[
        {value:SiteSettingDictionary.INPUT_LABEL_WIDTH_FIXED,text:'固定宽度'},
        {value:SiteSettingDictionary.INPUT_LABEL_WIDTH_AUTO,text:'自动'}
    ];
    static languageSource=[
        {value:SiteSettingDictionary.LANGUAGE_ZH,text:'中文'},
        {value:SiteSettingDictionary.LANGUAGE_EN,text:'英文'}
    ];
    static currencySource=[
        {value:SiteSettingDictionary.CURRENCY_CNY,text:'人民币'},
        {value:SiteSettingDictionary.CURRENCY_USD,text:'美元'},
        {value:SiteSettingDictionary.CURRENCY_AED,text:'阿联酋迪拉姆'}
    ];

    static userFileServerSource=[
        {value:SiteSettingDictionary.USER_FILE_SERVER_NORMAL,text:'网站'},
        {value:SiteSettingDictionary.USER_FILE_SERVER_COS,text:'腾讯云'},
    ];

    static priceResultModeSource=[
        {value:SiteSettingDictionary.PRICE_RESULT_MODE_DISCOUNT,text:'折扣'},
       // {value:SiteSettingDictionary.PRICE_RESULT_MODE_COMMISSION,text:'佣金'},
        {value:SiteSettingDictionary.PRICE_RESULT_MODE_MARKUP,text:'上浮'}
    ];
    static priceListModeSource=[
        {value:SiteSettingDictionary.PRICE_LIST_MODE_NONE,text:'不显示'},
        {value:SiteSettingDictionary.PRICE_LIST_MODE_MEMBER,text:'会员价'},
        {value:SiteSettingDictionary.PRICE_LIST_MODE_COMMISSION,text:'佣金'}
    ];

    static addressFormatSource=[
        {value:SiteSettingDictionary.ADDRESS_FORMAT_FORMATTED,text:'有格式'},
        {value:SiteSettingDictionary.ADDRESS_FORMAT_UNFORMATTED,text:'无格式'},
    ]
    
}